var _G, _Defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Path, Defs } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */
var SvgOnlineInnerGlow = function SvgOnlineInnerGlow(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 129.022 128.908"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    filter: "url(#online-inner-glow_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "#330E07",
    fillRule: "evenodd",
    d: "M64.51 8.1c31.156 0 56.412 25.23 56.412 56.354s-25.256 56.354-56.411 56.354S8.1 95.578 8.1 64.454 33.356 8.1 64.51 8.1",
    clipRule: "evenodd"
  }))), _Defs || (_Defs = /*#__PURE__*/React.createElement(Defs, null)));
};
export default SvgOnlineInnerGlow;